import React, { useMemo } from 'react';
import './ActivateMultipleSchemesModal.scss';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { compose } from 'redux';

import { actions } from '../../redux/ProductReducer';
import { DatePicker } from '../../../../common/components';
import { Field, Form, getFormValues, reduxForm } from 'redux-form';
import Button from '../../../../common/components/Button/Button';
import FieldFormControl from '../../../../common/components/FieldFormControl/FieldFormControl';

const isRequired = (value) => {
  if (value === false) {
    return null;
  }

  return !value ? 'This field is required.' : null;
};

const bySchemeType = (schemes, isSchemeGroup) => {
  return schemes?.reduce((carry, scheme) => {
    const schemeType = isSchemeGroup
      ? scheme.attributes.group_key
      : scheme.attributes.scheme_type;
    if (!carry[schemeType]) {
      carry[schemeType] = [scheme];
      return carry;
    }
    carry[schemeType].push(scheme);
    return carry;
  }, {});
};

const SchemesInTest = ({ schemes, isSchemeGroup }) => {
  const schemesByType = useMemo(() => bySchemeType(schemes, isSchemeGroup), [
    schemes,
    isSchemeGroup,
  ]);

  const schemeTypes = Object.keys(schemesByType);
  return (
    <>
      {schemeTypes.map((schemeType) => {
        const schemeList = schemesByType[schemeType];
        return (
          <div className="activate-scheme-item-container">
            <h4 className={'capitalise'}> {schemeType} Schemes:</h4>
            {schemeList?.map((scheme) => {
              return (
                <div key={scheme.id}>
                  <Field
                    name={`schemes[${scheme.id}].activate`}
                    type="checkbox"
                    value={scheme.id}
                    component={FieldFormControl}
                  >
                    <div className="activate-scheme-item">
                      <h4>
                        {scheme.attributes.name} - V{scheme.attributes.version}
                      </h4>
                    </div>
                  </Field>
                </div>
              );
            })}
          </div>
        );
      })}
    </>
  );
};

const ActivateMultipleSchemesForm = ({
  isSchemeGroup,
  activateScheme,
  handleSubmit,
  submitting,
  schemes,
  onRefreshPage,
}) => {
  const activate = (formValues) => {
    const values = {
      meta: formValues.meta,
    };

    const formSchemes = formValues?.schemes ?? [];
    const schemesToActivate = Object.keys(formSchemes).filter((schemeId) => {
      return formSchemes[schemeId].activate;
    });

    const promises = [];
    schemesToActivate.map((activateId) => {
      promises.push(activateScheme(activateId, values, isSchemeGroup));
    });
    return Promise.all(promises).finally(() => {
      onRefreshPage();
    });
  };

  return (
    <Form onSubmit={handleSubmit(activate)}>
      <Modal.Body>
        <h3>Select schemes to activate:</h3>
        <p>
          Please note: Once the scheme has been made active it will no longer be available
          for editing.
        </p>

        <p>
          Have you remembered to imported your rates? Rates are not saved to the scheme
          until they are imported
        </p>
        {/*{this.renderSchemesInTest()}*/}
        <SchemesInTest schemes={schemes} isSchemeGroup={isSchemeGroup} />
        <h3 className="margin-top">Select a start date:</h3>
        <Field
          showTime
          dateFormat={'dd/MM/yyyy HH:mm'}
          labelSize={4}
          name="meta.date"
          label="Start date"
          timeFormat="HH:mm"
          validate={isRequired}
          component={DatePicker}
          shouldCloseOnSelect={false}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button className="btn-blue" type={'submit'} isLoading={submitting}>
          Activate
        </Button>
      </Modal.Footer>
    </Form>
  );
};

const FORM_NAME = 'ActivateMultipleSchemes';

export default compose(
  connect(
    (state, props) => {
      const schemeIds = props.schemes?.reduce((carry, scheme) => {
        carry[scheme.id] = {
          activate: false,
        };
        return carry;
      }, {});

      return {
        formValues: getFormValues(FORM_NAME)(state),
        initialValues: {
          schemes: schemeIds,
        },
      };
    },
    {
      activateScheme: actions.activateScheme,
    },
  ),
  reduxForm({
    form: FORM_NAME,
  }),
)(ActivateMultipleSchemesForm);
